/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { add2000Years, ConvertForDataTestPipe } from '@common/tech-shared';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControlEditorAbstractComponent } from '@ods/component';
import { IconComponent } from '@ods/system';
import { isDate } from 'date-fns';
import { ValidationErrorComponent } from '../../validation-error/validation-error.component';

@Component({
  selector: 'ozgcloud-date-editor',
  templateUrl: './date-editor.component.html',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    IconComponent,
    ValidationErrorComponent,
    MatDatepickerModule,
    ConvertForDataTestPipe,
  ],
})
export class DateEditorComponent extends FormControlEditorAbstractComponent {
  @Input() label: string;
  @Input() required: boolean = false;

  inputEvent(event: MatDatepickerInputEvent<Date>): void {
    this.onChange(event.value);
  }

  onBlur(): void {
    if (!isDate(this.fieldControl.value)) {
      return;
    }

    const value: Date = add2000Years(this.fieldControl.value);

    this.fieldControl.patchValue(value);
    this.onChange(value);
  }
}
